export default "https://cdn-static.gokick.com/assets/09fae944e838c54f14fd77486c4f90b3472cb396/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";